/**
 * @flow
 * @relayHash 08340d268fceefb25d22fa7e2634459b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type home_viewer$ref = any;
export type home_Refetch_QueryVariables = {||};
export type home_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: home_viewer$ref
  |}
|};
export type home_Refetch_Query = {|
  variables: home_Refetch_QueryVariables,
  response: home_Refetch_QueryResponse,
|};
*/


/*
query home_Refetch_Query {
  viewer {
    ...home_viewer
    id
  }
}

fragment home_viewer on Viewer {
  ...ArticleSelector_viewer
  main: articles(first: 1, hidden: false, h: true) {
    edges {
      node {
        id
        slug
        mainPageOrder
        title
        categoryName
        availableAt
        preview {
          filename
          type
          preview
          id
        }
      }
    }
  }
  news: articles(first: 3, section: "U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=", d: true, h: false, hidden: false) {
    edges {
      node {
        id
        slug
        title
        mainPageOrder
        categoryName
        availableAt
        preview {
          filename
          type
          preview
          id
        }
      }
    }
  }
  articles: articles(first: 3, section: "U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=", d: true, h: false, hidden: false) {
    edges {
      node {
        id
        slug
        mainPageOrder
        title
        categoryName
        availableAt
        preview {
          filename
          type
          preview
          id
        }
      }
    }
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "Literal",
  "name": "hidden",
  "value": false,
  "type": "Boolean"
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mainPageOrder",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "availableAt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "preview",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaFile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "filename",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "preview",
      "args": null,
      "storageKey": null
    },
    v1
  ]
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "ArticleEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Article",
        "plural": false,
        "selections": [
          v1,
          v3,
          v4,
          v2,
          v5,
          v6,
          v7
        ]
      }
    ]
  }
],
v9 = {
  "kind": "Literal",
  "name": "d",
  "value": true,
  "type": "Boolean"
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 3,
  "type": "Int"
},
v11 = {
  "kind": "Literal",
  "name": "h",
  "value": false,
  "type": "Boolean"
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "home_Refetch_Query",
  "id": null,
  "text": "query home_Refetch_Query {\n  viewer {\n    ...home_viewer\n    id\n  }\n}\n\nfragment home_viewer on Viewer {\n  ...ArticleSelector_viewer\n  main: articles(first: 1, hidden: false, h: true) {\n    edges {\n      node {\n        id\n        slug\n        mainPageOrder\n        title\n        categoryName\n        availableAt\n        preview {\n          filename\n          type\n          preview\n          id\n        }\n      }\n    }\n  }\n  news: articles(first: 3, section: \"U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=\", d: true, h: false, hidden: false) {\n    edges {\n      node {\n        id\n        slug\n        title\n        mainPageOrder\n        categoryName\n        availableAt\n        preview {\n          filename\n          type\n          preview\n          id\n        }\n      }\n    }\n  }\n  articles: articles(first: 3, section: \"U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=\", d: true, h: false, hidden: false) {\n    edges {\n      node {\n        id\n        slug\n        mainPageOrder\n        title\n        categoryName\n        availableAt\n        preview {\n          filename\n          type\n          preview\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "home_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "home_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "home_Refetch_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              v0,
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  v2
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "main",
            "name": "articles",
            "storageKey": "articles(first:1,h:true,hidden:false)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "h",
                "value": true,
                "type": "Boolean"
              },
              v0
            ],
            "concreteType": "ArticleConnection",
            "plural": false,
            "selections": v8
          },
          {
            "kind": "LinkedField",
            "alias": "news",
            "name": "articles",
            "storageKey": "articles(d:true,first:3,h:false,hidden:false,section:\"U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=\")",
            "args": [
              v9,
              v10,
              v11,
              v0,
              {
                "kind": "Literal",
                "name": "section",
                "value": "U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=",
                "type": "ID"
              }
            ],
            "concreteType": "ArticleConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ArticleEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Article",
                    "plural": false,
                    "selections": [
                      v1,
                      v3,
                      v2,
                      v4,
                      v5,
                      v6,
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articles",
            "storageKey": "articles(d:true,first:3,h:false,hidden:false,section:\"U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=\")",
            "args": [
              v9,
              v10,
              v11,
              v0,
              {
                "kind": "Literal",
                "name": "section",
                "value": "U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=",
                "type": "ID"
              }
            ],
            "concreteType": "ArticleConnection",
            "plural": false,
            "selections": v8
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1a78a050061ee4b9ef7402fddd6384f3';
module.exports = node;



// WEBPACK FOOTER //
// src/components/home/__generated__/home_Refetch_Query.graphql.js